"use client";
import React, { useEffect, useState } from "react";
import { BlackCross_24x24 } from "../../../public/Theme";
import Image from "next/image";
import { INTL_BANNER_TEXT, UAE_BANNER_TEXT } from "./constants";
import TextRotator from "../TextRotator";

const PageTopBanner = ({ countryFlag }) => {
    const [showBanner, setShowBanner] = useState(true);
    const [bannerText, setBannerText] = useState(INTL_BANNER_TEXT);
    useEffect(() => {
        if (countryFlag)
            countryFlag?.toLowerCase() === "ae"
                ? setBannerText(UAE_BANNER_TEXT)
                : setBannerText(INTL_BANNER_TEXT);
    }, [countryFlag]);

    return (
        showBanner && (
            <div className="h-12 sm:h-10 bg-Banner_Background py-3 px-4 flex justify-between items-center">
                <div className="w-[95%]">
                    <TextRotator textArray={bannerText} />
                </div>
                <Image
                    onClick={() => setShowBanner(false)}
                    width={0}
                    height={0}
                    className={"cursor-pointer w-3 sm:w-4 h-3 sm:h-4"}
                    src={BlackCross_24x24}
                    alt="Cross Icon"
                />
            </div>
        )
    );
};

export default PageTopBanner;
